import React, { useState } from 'react';
import BsModal from '../Common/BsModal';
import ajaxStaff from '../../util/remote/ajaxStaff';
import { useTheme } from '../../DataStore/ThemeContext';
import { useStaff } from '../../DataStore/StaffContext';
import Notification from '../Common/Notification';
import ActivityLoader from '../Common/ActivityLoader';

const AlertRemoveLoad = ({handleClose, show, load, callback}) => {

    const {setNotify} = useTheme();
    const [loading, setLoading] = useState(false);
    const {loadProfile} = useStaff();

    const confirm = async()=>{
        setLoading(true);
        const server_response = await ajaxStaff.removeStaffLoad(load.id);
        setLoading(false);
        if(server_response.status === "OK"){
            setNotify(<Notification type='success' message={server_response.message}/>);
            callback();
            loadProfile(load.teacher_id);
        }
        else {
            setNotify(<Notification type='danger' message={server_response.message}/>);
        }
        handleClose();
    }

    return (
        <BsModal
            show={show}
            onClose={handleClose}
            title="Remove Staff Load"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                        <button className="btn btn-secondary" onClick={handleClose}>
                            Cancel
                        </button>
                        <button className="btn btn-danger" onClick={confirm}>
                            Confirm
                        </button>
                    </>}
                </>
            }
        >


            <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>Please confirm that you want to remove this selected teaching load from the staff.</h5>
           
            </div>
          

        </BsModal>
    );
};

export default AlertRemoveLoad;
